import { Instance, types } from 'mobx-state-tree';

const Role = types.model('RoleType', {
	id: types.number,
	name: types.string,
	permissions: types.optional(types.array(types.string), []),
});

export default Role;

export interface IRoleModel extends Instance<typeof Role> {}
